import {createReducer, createActions} from 'reduxsauce'
import Immutable from 'seamless-immutable'

/* ------------- Types and Action Creators ------------- */

const {Types, Creators} = createActions({
  topPerformingAdminSetProp: ['key', 'value'],
  topPerformingAdminReset: null,
})

export const TopPerformingAdminTypes = Types
export default Creators

/* ------------- Initial State ------------- */

export const INITIAL_STATE = Immutable({
  date: [],

  subPage: 'Prepared',
})

/* ------------- Selectors ------------- */
export const getState = state => state.topPerformingAdmin

export const topPerformingAdminSetProp = (state, {key, value}) => {
  return state.set(key, value)
}

export const topPerformingAdminReset = state => {
  return state.merge({
    date: [],
  })
}

/* ------------- Hookup Reducers To Types ------------- */
export const reducer = createReducer(INITIAL_STATE, {
  [Types.TOP_PERFORMING_ADMIN_SET_PROP]: topPerformingAdminSetProp,
  [Types.TOP_PERFORMING_ADMIN_RESET]: topPerformingAdminReset,
})
